export const vsCodeIpad = require("./shells_ipad_vscode-fs8.png");
